import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 489C9004-CF90-483E-83E3-CD40DD5B9ACF
 * name multiplication
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/multiplication.svg
 * tags
 * - Math 
 */
export const MultiplicationIcon = createSvgIcon(<><path d="M11,3H13V10.27L19.29,6.64L20.29,8.37L14,12L20.3,15.64L19.3,17.37L13,13.72V21H11V13.73L4.69,17.36L3.69,15.63L10,12L3.72,8.36L4.72,6.63L11,10.26V3Z" /></>, 'MultiplicationIcon');
export default MultiplicationIcon